import { Link } from "react-router-dom";

// Shared button. variant: 'gold' (primary CTA) or 'outline'.
export const Button = ({ to, href, variant = "gold", className = "", children, ...rest }) => {
  const base =
    "btn-sheen inline-flex items-center justify-center gap-2 px-7 py-4 font-mono text-xs uppercase tracking-[0.18em] transition-all duration-300 will-change-transform";
  const styles = {
    gold: "bg-gold text-ink hover:-translate-y-0.5 hover:shadow-[0_12px_30px_-8px_rgba(192,138,62,0.6)]",
    outline:
      "border border-ink/25 text-ink hover:border-ink hover:-translate-y-0.5 hover:bg-ink hover:text-cream",
    ghostLight:
      "border border-cream/25 text-cream hover:border-cream hover:bg-cream hover:text-ink hover:-translate-y-0.5",
  };
  const cls = `${base} ${styles[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
};
